import config from 'config';
import axios, { AxiosResponse } from 'axios';

export const deconstructWaveHeight = (
  waveHeight: string,
): { min: number; max: number; plus: boolean } => {
  const waveHeightParts = waveHeight.split('-');
  const plus = waveHeightParts[1] ? waveHeightParts[1].includes('+') : false;
  return {
    min: waveHeightParts[0] ? parseInt(waveHeightParts[0], 10) : 0,
    max: waveHeightParts[1] ? parseInt(waveHeightParts[1].replace('+', ''), 10) : 1,
    plus,
  };
};

export const createYesResponse = async (
  accessToken: string,
  spotId: string,
  waveHeightSetting: string,
  windSpeedSetting: string,
  timestampFormatted: string,
): Promise<AxiosResponse> =>
  axios({
    method: 'post',
    url: `${config.servicesURL}/kbyg/feedback`,
    headers: {
      ...(accessToken && { 'x-auth-accessToken': `${accessToken}` }),
    },
    data: {
      spotId,
      timestamp: timestampFormatted,
      units: {
        waveHeight: waveHeightSetting,
        windSpeed: windSpeedSetting,
      },
      rating: {
        accurate: true,
      },
      surf: {
        accurate: true,
      },
      wind: {
        accurate: true,
      },
    },
  });

export const createNoResponse = async (
  accessToken: string,
  spotId: string,
  waveHeightSetting: string,
  waveHeight: string,
  rating: string,
  wind: string,
  windSpeedSetting: string,
  notes: string | undefined,
  timestampFormatted: string,
): Promise<AxiosResponse> => {
  const waveHeightParts = deconstructWaveHeight(waveHeight);
  return axios({
    method: 'post',
    url: `${config.servicesURL}/kbyg/feedback`,
    headers: {
      ...(accessToken && { 'x-auth-accessToken': `${accessToken}` }),
    },
    data: {
      spotId,
      timestamp: timestampFormatted,
      units: {
        waveHeight: waveHeightSetting,
        windSpeed: windSpeedSetting,
      },
      rating: {
        accurate: false,
        key: rating,
      },
      surf: {
        accurate: false,
        min: waveHeightParts.min,
        max: waveHeightParts.max,
        plus: waveHeightParts.plus,
      },
      wind: {
        accurate: wind === 'yes',
      },
      notes,
    },
  });
};
